import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HelpCenterIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_595_3565)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M16.3125 11.8125V14.0625",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M1.6875 14.0625V6.1875C1.6875 5.88914 1.80603 5.60298 2.01701 5.39201C2.22798 5.18103 2.51414 5.0625 2.8125 5.0625H5.625",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.938 14.0625C10.7428 14.4042 10.4607 14.6882 10.1204 14.8857C9.78 15.0833 9.39352 15.1873 9 15.1873C8.60648 15.1873 8.22 15.0833 7.87965 14.8857C7.5393 14.6882 7.25721 14.4042 7.062 14.0625H0.5625V15.1875C0.5625 15.7842 0.799553 16.3565 1.22151 16.7785C1.64347 17.2004 2.21576 17.4375 2.8125 17.4375H15.1875C15.7842 17.4375 16.3565 17.2004 16.7785 16.7785C17.2004 16.3565 17.4375 15.7842 17.4375 15.1875V14.0625H10.938Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M14.0666 0.762293C13.184 0.498585 12.2441 0.495875 11.3602 0.754485C10.4762 1.0131 9.68596 1.52199 9.08476 2.21975C8.48356 2.91752 8.09716 3.77433 7.97206 4.68683C7.84704 5.59934 7.98871 6.52853 8.38006 7.36229L6.83203 10.5041L10.3743 9.53655C10.6868 9.71558 11.0186 9.85823 11.3636 9.9618C12.5764 10.2972 13.8725 10.1422 14.9721 9.53033C16.0718 8.91848 16.8867 7.89878 17.2412 6.69135C17.5955 5.4839 17.461 4.18551 16.8665 3.0764C16.272 1.96729 15.2653 1.1364 14.0636 0.763043L14.0666 0.762293Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M11.3281 4.24683C11.3281 3.96869 11.4106 3.69681 11.5651 3.46556C11.7196 3.2343 11.9393 3.05405 12.1962 2.94762C12.4532 2.84119 12.736 2.81333 13.0087 2.8676C13.2815 2.92186 13.5321 3.0558 13.7287 3.25246C13.9255 3.44913 14.0593 3.6997 14.1136 3.97248C14.1679 4.24526 14.14 4.52801 14.0336 4.78498C13.9272 5.04194 13.7469 5.26156 13.5157 5.41608C13.2844 5.5706 13.0125 5.65307 12.7344 5.65307",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12.7344 7.90311C12.579 7.90311 12.4531 7.77719 12.4531 7.62186C12.4531 7.4665 12.579 7.34058 12.7344 7.34058",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12.7344 7.90311C12.8897 7.90311 13.0156 7.77719 13.0156 7.62186C13.0156 7.4665 12.8897 7.34058 12.7344 7.34058",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_595_3565",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
